import { DotIcon } from "@/icon/DotIcon";
import { HStack } from "@chakra-ui/react";
import React, { Fragment, memo } from "react";

export default memo(function PaginationComponent({ activeIndex }) {
   return (
      <HStack spacing={"20px"} pos={'absolute'} bottom={{base:'20px',BREAK_PAD:'10px'}}>
         {[0, 1, 2, 3, 4].map((index) => {
            return <Fragment key={index}>
               <DotIcon color={index === activeIndex ? "green.500" : "#E7E7E7"} boxSize={"10px"} />
            </Fragment>
         })}
      </HStack>
   );
});
